import React from 'react';
import useGetMobileAppDownloadUrl from '@/hooks/useGetMobileAppDownloadUrl';
import { cdnImage } from '@/utils/image-utils';
import { CDN_IMAGES_COMMON_PATH } from '@/constants/constants';
import { AbsoluteNavLink } from '@/components/AbsoluteNavLink';
import { closeDrawer } from '@/store/ui/actions';
import { useDispatch } from 'react-redux';

const MobileAppDownload = () => {
  const mobileApps = useGetMobileAppDownloadUrl();
  const dispatch = useDispatch();

  if (mobileApps.length > 0) {
    return (
      <>
        {mobileApps.map(({ mobileAppPromotionUrl, image }, index) => {
          if (!mobileAppPromotionUrl || !image) {
            return null;
          }

          return (
            <AbsoluteNavLink
              key={`mobile-app-promo-${index}`}
              onClick={() => dispatch(closeDrawer())}
              to={mobileAppPromotionUrl}
            >
              <img
                src={cdnImage(image, {
                  width: '150px',
                  height: 'auto',
                  path: CDN_IMAGES_COMMON_PATH,
                })}
                className="max-h-[44px]"
                alt={image}
              />
            </AbsoluteNavLink>
          );
        })}
      </>
    );
  }
  return null;
};

export default MobileAppDownload;
